export function getReferralBaseLink(exchange: string): string {
    if(exchange === 'Binance') return 'https://binance.com/'
    if(exchange === 'BitMEX') return 'https://bitmex.com'
    if(exchange === 'OKX') return 'https://www.okx.com'
    if(exchange === 'PerpProtocol') return 'https://app.perp.com'
    return ''
}